export default __webpack_public_path__ + "static/media/model.fc1e9f07.md";